/**
 * QR Code Components Export
 * 
 * All QR-related functionality is self-contained in this directory.
 * To remove QR functionality:
 * 1. Delete src/components/qr/ directory
 * 2. Remove imports from parent components
 * 3. Remove route from AppRouter.tsx
 * 4. Uninstall qrcode.react package
 */

export { QRCodeDisplay, generateShipmentQRValue, generateInvoiceQRValue, generateSourcingRequestQRValue, parseQRValue } from './QRCodeDisplay';
export { QRScanner } from './QRScanner';
export { default as ScanPage } from './ScanPage';
export { QRButton } from './QRButton';